import { render, staticRenderFns } from "./BookingsPage.vue?vue&type=template&id=d6afa34a"
import script from "./BookingsPage.vue?vue&type=script&lang=js"
export * from "./BookingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports